// ------------- import xternal dependencies ------------
import { StateCreator } from "zustand";

// ----------- import internal dependencies -----------
import { AddUserSliceType, AssignmentType, PersonalDataType } from "./type";
import { addToResetFnsSet } from "./store";

const assignmentTemplate: AssignmentType = {
  facility: { facilityName: "", facilityId: "" },
  role: { roleName: "", roleId: "" },
  profile: { profileName: "", profileId: "" },
  completed: false,
};

const initialState = {
  title: "",
  firstName: "",
  lastName: "",
  userName: "",
  completed: false,
  editIndex: 0,
  email: "",
  stage: 1,
  edit: false,
  assignment: [{ ...assignmentTemplate }],
};

const createAddUserSlice: StateCreator<AddUserSliceType> = (set) => {
  const reset = () => set(initialState);
  addToResetFnsSet(reset);
  return {
    ...initialState,
    updateStage(stage) {
      return set((state) => {
        return {
          stage: state.edit
            ? stage
            : state.stage < 3
              ? state.stage + 1
              : state.stage,
        };
      });
    },
    setEdit(status) {
      return set(() => {
        return {
          edit: status,
        };
      });
    },
    clearState(field, ind) {
      return set((state) => {
        const copyAss = [...state.assignment];
        copyAss[ind] = {
          ...copyAss[ind],
          [field]: assignmentTemplate[field as "profile" | "facility" | "role"],
        };

        return {
          assignment: [...copyAss],
        };
      });
    },
    updateField(ind, val, field) {
      return set((state) => {
        const copyAss = [...state.assignment];
        copyAss[ind] = {
          ...copyAss[ind],
          [field as any]: val,
        };

        return {
          assignment: [...copyAss],
        };
      });
    },
    addAssignment: () =>
      set((state) => {
        return {
          assignment: [...state.assignment, { ...assignmentTemplate }],
          completed: false,
          editIndex:
            state.editIndex !== null
              ? (state.editIndex as number) + 1
              : state.assignment.length,
        };
      }),
    updatePersonalData({
      title,
      firstName,
      lastName,
      userName,
    }: PersonalDataType) {
      return set((state) => ({
        title,
        firstName,
        lastName,
        userName,
      }));
    },
    updateEmail(email: string) {
      return set((state) => ({
        email,
      }));
    },
    updateAssignment(assignment, ind) {
      return set((state) => {
        // ------ copy assignmemnt Array -------
        const copyArr = [...state.assignment];

        // ------- update assignment -------
        copyArr.splice(ind, 1, assignment);

        return {
          assignment: copyArr,
          completed: true,
          editIndex: null,
        };
      });
    },
    editAssignment(assignment, ind) {
      return set((state) => {
        // ------ copy assignment Array -------
        const copyAssignments = [...state.assignment];

        // ------- update assignment -------
        copyAssignments.splice(ind, 1, assignment);

        return {
          assignment: copyAssignments,
          completed: false,
          editIndex: ind,
        };
      });
    },
    removeAssignment(ass, ind) {
      return set((state) => {
        // ------ copy assignmemnt Array -------
        const copyAssignments = [...state.assignment];

        // ------- remove assignment -------
        copyAssignments.splice(ind, 1);

        // -------- check for the completed state to update global complete state -------
        return ass.completed
          ? {
              assignment: [...copyAssignments],
            }
          : {
              assignment: [...copyAssignments],
              completed: true,
            };
      });
    },
    resetUser() {
      return set((state) => {
        return {
          ...initialState,
        };
      });
    },
    resetAddUser: reset,
  };
};

export default createAddUserSlice;
